var map = {
	"./sicbo_en.png": "fBcV",
	"./sicbo_th.png": "cuWy"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3sLk";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa ^\.\/sicbo_.*\.png$
// module id = 3sLk
// module chunks = 1